import React, {useContext, useEffect, useState} from 'react';
import { Field } from 'react-final-form';
import RadioButton from './RadioBig';
import Grid from "@material-ui/core/Grid";
import Select from "./Select";
import styled from "styled-components";
import { Trans } from "../utils/i18n";
import {useFormState, useFormStateDispatch} from "../FormComponents/FormState";

const ProductItem = styled.div`
    transition: background-color .2s,color .2s;
    border: 2px solid ${props => props.theme.gray};
    border-radius: 5px;
`;

const ProductSelect = React.memo(function ({ product, form }) {
        const orderEntryDispatch = useFormStateDispatch();
        const { products } = useFormState();

        useEffect(() => {
            fetch(route('order.products'))
                .then(response => response.json())
                .then(response => {
                    if(!response.success) {
                        throw 'error';
                    }
                    orderEntryDispatch({ type: 'setProducts', value: response.products });
                })

        }, []);

        useEffect(() => {
            if (products && products.length === 1) {
                form.change('product', String(products[0].id));
            }
        }, [products]);

        useEffect(() => {
            if (products) {
                form.change('productvariant', undefined);
            }
        }, [product]);

        if (!products) {
            return <div><Trans i18nKey="productSelect.loading">Loading</Trans></div>;
        }

        const currentProduct = products && products.find(item => String(item.id) === product);

        return (
            <div>
                <Grid container spacing={3}>
                    {
                        products
                            .map((item) =>
                                <Grid item xs={12} sm={4} key={item.id}>
                                    <Field
                                        name={'product'}
                                        type={'radio'}
                                        value={String(item.id)}
                                        //placeholder={field.placeholder}
                                        component={RadioButton}
                                        validate={value => (value ? undefined : <Trans i18nKey="productSelect.required">Required</Trans>)}
                                        field={{
                                            label: item.label + '(' + item.price + ')',
                                            titel: item.description,
                                            price: item.price,
                                            image: item.image,
                                        }}
                                    />
                                </Grid>,
                            )
                    }
                </Grid>

                { currentProduct && currentProduct?.coverages?.length > 0 &&
                <div>
                    <hr/>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={8}>
                            <h3>
                              <Trans i18nKey="productSelect.coverage">Coverage</Trans>
                            </h3>
                            <p>
                              <Trans i18nKey="productSelect.coverage.description">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</Trans>
                            </p>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                        {
                            currentProduct.coverages
                                .map((item) =>
                                    <Grid item xs={12} sm={4} key={item.name}>
                                        <Field
                                            name={'coverage_id'}
                                            type={'radio'}
                                            value={String(item.id)}
                                            component={RadioButton}
                                            validate={value => (value ? undefined : <Trans i18nKey="productSelect.required">Required</Trans>)}
                                            field={{
                                                titel: item.name,
                                                description: item.description,
                                            }}
                                        />
                                    </Grid>
                                )
                        }
                    </Grid>
                </div>
                }
            </div>
        );
    },
    function areEqual(prevProps, nextProps) {
        return JSON.stringify(prevProps) === JSON.stringify(nextProps);
    });

export default ProductSelect;
